"use client";

import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { homeFaqs } from "@/lib/data/site";
import { SectionHeader } from "@/components/ui/section-header";
import { cn } from "@/lib/utils";

export function HomeFaq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="relative overflow-hidden py-20 sm:py-24 md:py-32" id="faq">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_50%_0%,var(--hero-glow-1),transparent_55%)]" />
      <div className="container-wide relative">
        <SectionHeader
          eyebrow="FAQ"
          title={"ANSWERS BEFORE\nYOU ENGAGE."}
          description="Common questions from product leaders and CTOs evaluating a custom software development, AI engineering, or dedicated team partner."
        />

        <div className="mx-auto mt-12 max-w-3xl space-y-3 sm:mt-14">
          {homeFaqs.map((item, index) => {
            const isOpen = open === index;
            return (
              <div
                key={item.question}
                className="overflow-hidden rounded-2xl border border-border bg-card/70 backdrop-blur-xl"
              >
                <button
                  type="button"
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left sm:px-6 sm:py-5"
                  aria-expanded={isOpen}
                  onClick={() => setOpen(isOpen ? null : index)}
                >
                  <span className="font-display text-base tracking-tight text-foreground sm:text-lg">
                    {item.question}
                  </span>
                  <Plus
                    className={cn(
                      "h-5 w-5 shrink-0 text-accent transition-transform duration-300",
                      isOpen && "rotate-45",
                    )}
                  />
                </button>
                <AnimatePresence initial={false}>
                  {isOpen ? (
                    <motion.div
                      key="content"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="border-t border-border px-5 pb-5 pt-4 text-sm leading-relaxed text-muted sm:px-6 sm:pb-6">
                        {item.answer}
                      </p>
                    </motion.div>
                  ) : null}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
